import React from "react";
import styled from "styled-components";

const Container = styled.section`
  text-align: center;
`;

const LogosContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  gap: 5%;
  background-color: #fff;
  height: auto;
`;

const LogoWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 140px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Logo = styled.img`
  width: ${({ width }) => width}px;
  height: auto;
`;

const LogoName = styled.p`
  margin-top: 10px;
  font-size: 14px;
  color: #333;
`;

const Partners = () => {
  const companyData = [
    {
      name: "مرکز ارزیابی پزشکی فوتبال",
      logo: "partners/ifmarc.png",
      width: 150,
    },
    {
      name: "کلینیک پزشکی ورزشی ایرانمال",
      logo: "partners/ifmark.png",
      width: 160,
    },
    {
      name: "سازمان لیگ فوتبال ایران",
      logo: "partners/league.png",
      width: 100,
    },
    {
      name: "فراسنجش هوشمند ایرسا شریف",
      logo: "partners/irsasharif.png",
      width: 140,
    },
  ];

  return (
    <Container>
      {/* <h1>همکاران ما</h1> */}
      <LogosContainer>
        {companyData.map((company, index) => (
          <LogoWrapper key={index}>
            <Logo
              src={company.logo}
              alt={`${company.name} Logo`}
              width={company.width}
            />
            <LogoName>{company.name}</LogoName>
          </LogoWrapper>
        ))}
      </LogosContainer>
    </Container>
  );
};

export default Partners;
